import { render, staticRenderFns } from "./RootPortinerieView.vue?vue&type=template&id=5df1cf92&"
import script from "./RootPortinerieView.vue?vue&type=script&lang=ts&"
export * from "./RootPortinerieView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports